import { Card, CardContent, CardHeader, FormControlLabel, FormLabel, Grid, Grid2, MenuItem, Radio, RadioGroup, Select, TextField } from "@mui/material";
import { FORM_TYPE, GOLONGAN_DARAH, JENIS_KELAMIN } from "../../helper/Constant";
import { useState, useEffect } from 'react';
import { Commons } from '../../helper/CommonService';
import { APP_HOST } from '../../helper/Constant';
import GridForm from "../general/GridForm";
import dayjs from "dayjs";
import GridDdlPlace from "../general/GridDdlPlace";

function DataSantri({ handleChange, data }) {
    const [isLoadingProvinsi, setIsLoadingProvinsi] = useState(true);
    const [isLoadingKabupaten, setIsLoadingKabupaten] = useState(true);
    const [isLoadingKecamatan, setIsLoadingKecamatan] = useState(true);
    const [isLoadingKelurahan, setIsLoadingKelurahan] = useState(true);
    const [provinsis, setProvinsis] = useState([]);
    const [kabupatens, setKabupatens] = useState([]);
    const [kecamatans, setKecamatans] = useState([]);
    const [kelurahans, setKelurahans] = useState([]);

    const GetKabupaten = (provinsiId) => {
        setIsLoadingKabupaten(true);
        Commons.GetData(APP_HOST + '/alamat/kabupaten-provinsi-' + provinsiId)
            .then((dataResponse) => {
                setKabupatens(dataResponse);
                setKecamatans([]);
                setKelurahans([]);
            })
            .catch((errResponse) => {
                console.log(errResponse);
            })
            .finally(() => {
                setIsLoadingKabupaten(false);
            });
    }

    const GetKecamatan = (kabupatenId) => {
        setIsLoadingKecamatan(true);
        Commons.GetData(APP_HOST + '/alamat/kecamatan-kabupaten-' + kabupatenId)
            .then((dataResponse) => {
                setKecamatans(dataResponse);
                setKelurahans([]);
            })
            .catch((errResponse) => {
                console.log(errResponse);
            })
            .finally(() => {
                setIsLoadingKecamatan(false);
            });
    }

    const GetKelurahan = (kecamatanId) => {
        setIsLoadingKelurahan(true);
        Commons.GetData(APP_HOST + '/alamat/kelurahan-kecamatan-' + kecamatanId)
            .then((dataResponse) => {
                setKelurahans(dataResponse);
            })
            .catch((errResponse) => {
                console.log(errResponse);
            })
            .finally(() => {
                setIsLoadingKelurahan(false);
            });
    }

    useEffect(() => {
        setIsLoadingProvinsi(true);
        Commons.GetData(APP_HOST + '/alamat/provinsi')
            .then((dataResponse) => {
                setProvinsis(dataResponse);
                setIsLoadingProvinsi(false);
                setIsLoadingKabupaten(true);
                if (data?.provinsi && data?.kabupaten && data?.kecamatan && data?.kelurahan) {
                    let provinsiId = dataResponse.find((item) => item.nama_provinsi === data.provinsi).id_provinsi;
                    Commons.GetData(APP_HOST + '/alamat/kabupaten-provinsi-' + provinsiId)
                        .then((dataKabupaten) => {
                            setKabupatens(dataKabupaten);
                            setIsLoadingKabupaten(false);
                            setIsLoadingKecamatan(true);
                            let kabupatenId = dataKabupaten.find((item) => item.nama_kabupaten_kota === data.kabupaten).id_kabupaten_kota;
                            Commons.GetData(APP_HOST + '/alamat/kecamatan-kabupaten-' + kabupatenId)
                                .then((dataKecamatan) => {
                                    setKecamatans(dataKecamatan);
                                    setIsLoadingKecamatan(false);
                                    setIsLoadingKelurahan(true);
                                    let kecamatanId = dataKecamatan.find((item) => item.nama_kecamatan === data.kecamatan).id_kecamatan;
                                    Commons.GetData(APP_HOST + '/alamat/kelurahan-kecamatan-' + kecamatanId)
                                        .then((dataKelurahan) => {
                                            setKelurahans(dataKelurahan);
                                            setIsLoadingKelurahan(false);
                                        });
                                });

                        });
                }
            })
            .catch((errResponse) => {
                console.log(errResponse);
            });
    }, []);

    return (
        <>
            <Card>
                <CardHeader title="Data Calon Santri" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                </CardHeader>
                <CardContent>
                    <Grid sx={{ padding: "10px" }} container spacing={2}>
                        {/* Row  */}
                        <GridForm titleForm={"Nama Calon Santri"} column={4} attribute={{ name: "nama", value: data?.nama }} isRequired={true} handleChange={handleChange}></GridForm>
                        <GridForm column={4} titleForm={"Alamat"} attribute={{ name: "alamat", value: data?.alamat, rows: 3, multiline: true }} isRequired={true} handleChange={handleChange}></GridForm>
                        <GridForm column={4} titleForm={"Cita-cita"} attribute={{ name: "cita_cita", value: data?.cita_cita }} isRequired={true} handleChange={handleChange}></GridForm>

                        {/* Row  */}
                        <GridForm column={4} titleForm={"Tempat Lahir"} attribute={{ name: "tempat_lahir", value: data?.tempat_lahir }} isRequired={true} handleChange={handleChange}></GridForm>
                        <GridDdlPlace titleForm="Provinsi" isRequired={true} columns={"4"} datahandler={(e) => {
                            handleChange(e.target.name, e.target.value);
                            GetKabupaten(provinsis.find((item) => item.nama_provinsi === e.target.value).id_provinsi);
                        }} isLoading={isLoadingProvinsi} datas={{ data: provinsis, keyName: "id_provinsi", valueName: "nama_provinsi" }} attribute={{ name: "provinsi", value: data?.provinsi }} ></GridDdlPlace>
                        <GridForm column={4} titleForm={"Hobi"} attribute={{ name: "hobi", value: data?.hobi }} isRequired={true} handleChange={handleChange}></GridForm>

                        {/* Row  */}
                        <GridForm type={FORM_TYPE.DATEPICKER} column={4} titleForm={"Tanggal Lahir"} attribute={{ name: "tanggal_lahir", value: (data?.tanggal_lahir) ? dayjs(data.tanggal_lahir) : null, format: "DD/MM/YYYY" }} isRequired={true} handleChange={handleChange}></GridForm>
                        <GridDdlPlace titleForm="Kota/Kabupaten" isRequired={true} columns={"4"} datahandler={(e) => {
                            handleChange(e.target.name, e.target.value);
                            GetKecamatan(kabupatens.find((item) => item.nama_kabupaten_kota === e.target.value).id_kabupaten_kota);
                        }} isLoading={isLoadingKabupaten} datas={{ data: kabupatens, keyName: "id_kabupaten_kota", valueName: "nama_kabupaten_kota" }}
                            attribute={{ name: "kabupaten", value: data?.kabupaten }} ></GridDdlPlace>
                        <GridForm column={4} titleForm={"Jumlah Juz Hafalan"} attribute={{ name: "jumlah_jus_hafalan", value: data?.jumlah_jus_hafalan }} isRequired={false} handleChange={handleChange}></GridForm>

                        {/* Row  */}
                        <Grid sx={{ padding: "5px" }} xs={12} xl={4} lg={4} sm={12} md={4}>
                            <FormLabel sx={{
                                color: "#000000", fontWeight: "bold", marginTop: "15px", "::after": {
                                    content: '" *Wajib Diisi"', // Adds custom " (*)" after the label text
                                    color: "red",      // Customize color
                                    fontWeight: "bold", // Customize font weight
                                    fontStyle: "italic"
                                }
                            }}>Jenis Kelamin</FormLabel>
                            <Select required value={data?.jenis_kelamin} onChange={(e) => { handleChange(e.target.name, e.target.value) }} name="jenis_kelamin" fullWidth>
                                {
                                    Object.entries(JENIS_KELAMIN).map(([key, valueJk]) => {
                                        return (
                                            <MenuItem value={valueJk} key={key}>{valueJk}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </Grid>
                        <GridDdlPlace titleForm="Kecamatan" isRequired={true} columns={"4"} datahandler={(e) => {
                            handleChange(e.target.name, e.target.value);
                            GetKelurahan(kecamatans.find((item) => item.nama_kecamatan === e.target.value).id_kecamatan);
                        }} isLoading={isLoadingKecamatan} datas={{ data: kecamatans, keyName: "id_kecamatan", valueName: "nama_kecamatan" }}
                            attribute={{ name: "kecamatan", value: data?.kecamatan }} ></GridDdlPlace>
                        <GridForm column={4} titleForm={"Nomor KK"} attribute={{ name: "no_kk", value: data?.no_kk, type: 'number' }} isRequired={true} handleChange={handleChange}></GridForm>

                        {/* Row  */}
                        <GridForm column={4} titleForm={"Jumlah Saudara Kandung"} attribute={{ name: "jumlah_saudara", value: data?.jumlah_saudara }} isRequired={true} handleChange={handleChange}></GridForm>
                        <GridDdlPlace titleForm="Kelurahan" isRequired={true} columns={"4"} datahandler={(e) => {
                            handleChange(e.target.name, e.target.value);
                        }} isLoading={isLoadingKelurahan} datas={{ data: kelurahans, keyName: "id_desa_kelurahan", valueName: "nama_desa_kelurahan" }}
                            attribute={{ name: "kelurahan", value: data?.kelurahan }} ></GridDdlPlace>
                        <GridForm column={4} titleForm={"Nomor Induk Siswa Nasional"} attribute={{ name: "nisn", value: data?.nisn }} isRequired={false} handleChange={handleChange}></GridForm>

                        {/* Row  */}
                        <GridForm column={4} titleForm={"Anak Ke"} attribute={{ name: "anak_ke", value: data?.anak_ke }} isRequired={true} handleChange={handleChange}></GridForm>
                        <GridForm column={4} titleForm={"Kode Pos"} attribute={{ name: "kode_pos", value: data?.kode_pos }} isRequired={false} handleChange={handleChange}></GridForm>
                        <GridForm column={4} titleForm={"Nomor Induk Kependudukan (NIK)"} attribute={{ name: "nik", value: data?.nik, type: 'number' }} isRequired={true} handleChange={handleChange}></GridForm>

                        {/* Row  */}
                        <Grid sx={{ padding: "5px" }} xs={12} xl={4} lg={4} sm={12} md={12}>
                            <FormLabel sx={{ color: "#000000", fontWeight: "bold", marginTop: "15px" }}>Golongan Darah</FormLabel>
                            <Select name="golongan_darah" onChange={(e) => { handleChange(e.target.name, e.target.value) }} value={data?.golongan_darah} fullWidth>
                                {
                                    Object.entries(GOLONGAN_DARAH).map(([key, value]) => {
                                        return (
                                            <MenuItem value={value} key={key}>{value}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </>
    );
}

export default DataSantri;